export default {
  BusinessPurchaseSupplier: {
    header: {
      code: 'Supplier Code',
      name: 'Supplier Name',
      classify: 'Project',
    },
    export: {
      downLoadName: 'Supplier Export',
      excelImport: 'Import',
      export: 'Export',
      rules: 'Excel Import Supplier Rule Explanation',
      p1: 'If the supplier code information already exists in the system, update the data according to the supplier code; otherwise, create a new supplier information.',
      p2: 'Import supplier information template, click to download',
      title: 'Supplier Information Template',
      p3: 'The imported Excel file must have a title row, with red columns being required; please set the columns in text format, otherwise type conversion errors may occur.',
      p4: 'Supported file formats: csv, xls, xlsx. The file size for a single import cannot exceed 128MB and the number of data rows cannot exceed 60,000. If it does, please divide into multiple imports.'
    },

    table: {
      code: 'Supplier Code',
      name: 'Supplier Name',
      classify: 'Project',
      supplierGrade: 'Supplier Level',
      proportion: 'Overfill Ratio',
      week: 'Delivery Cycle',
      invoicing: 'Default Invoice',
      taxRate: 'Default Tax Rate',
      paymentMethod: 'Default Billing Method',
      company: 'Company Name',
      mnemonicCode: 'Abbreviation',
      cooperationDate: 'Cooperation Date',
      contactPerson: 'Contact Person ',
      telephone: 'Telephone',
      phone: 'Mobile',
      address: 'Address',
      email: 'Email',
      account: 'Account Name',
      bankOfDeposit: 'Bank Name',
      bankAccount: 'Bank Account Number',
      remark: 'Remarks',
      changeTime: 'Modification Time',
    },

    dataForm: {
      title: 'Supplier Information',
      titleBtn: 'Operation Log',
      code: 'Supplier Code',
      name: 'Supplier Name',
      classify: 'Project',
      company: 'Company Name',
      supplierGrade: 'Supplier Level',
      mnemonicCode: 'Abbreviation',
      week: 'Delivery Cycle',
      proportion: 'Overfill Ratio',
      cooperationDate: 'Cooperation Date',
      invoicing: 'Default Invoice',
      paymentMethod: 'Default Billing Method',
      taxRate: 'Default Tax Rate',
      remark: 'Remark',
      contactPerson: 'Contact Person ',
      email: 'Email',
      telephone: 'Telephone',
      phone: 'Mobile',
      address: 'Address',
      account: 'Account Name',
      bankOfDeposit: 'Bank Name',
      bankAccount: 'Bank Account Number',
      cooperationDateText: 'Select Date and Time',
      contact: 'Contact Information',
      detailAddress: 'Detailed Address',
      bankInformation: 'Bank Information',
      codeRule: 'Please enter the supplier code',
      nameRule: 'Please enter the supplier name',
      edit: 'Edit',
      add: 'New',
      warning1: 'Supplier',
      warning2: 'Log',
      day: 'Days',
      taxCode: 'Tax Code',
      currency: 'currency',
      gl_Account: 'Gl_Account',
      systemCode: 'SystemCode',
    }

  }
};
